import { DEBT_PAGE } from "routes/route.constant";
import Debt from "./Debt";

const route = {
  path: DEBT_PAGE,
  element: Debt,
};

export default route;
